import {MinimalViewProcessDto} from '../services/generated';
import {ProcessBaseType} from './ProcessBaseType';

export class ProcessMinimal extends ProcessBaseType implements MinimalViewProcessDto {}
